import { useCallback } from 'react';

export const useClosePayeeDrawer = () =>
  useCallback(() => {
    window.dispatchEvent(
      new CustomEvent('payee-drawer-change-id', {
        bubbles: true,
        detail: { apPayeeId: '' },
      })
    );
  }, []);
